export default {
  bgImg:
    'https://mylink.oss-accelerate.aliyuncs.com/newMyCity/9.1%E5%9C%B0%E5%9B%BE_EN%20.png',
  consultation:
    'https://mylink.oss-accelerate.aliyuncs.com/mycity/banner/activity_en.png',
  cityImg:
    ' https://mylink.oss-accelerate.aliyuncs.com/mycity/%E5%9F%8E%E5%B8%82%E5%9C%B0%E5%9B%BEEN.png',
  mapImg:
    'https://mylink.oss-accelerate.aliyuncs.com/newMyCity/9.0.1/9.1%E5%9C%B0%E5%9B%BE_%E7%BC%A9%E7%95%A5%E5%9B%BE_EN.png',
  title1: 'City Map',
  title2: 'My Home',
  title3: 'Home',
  title4: ' My Menu',
  title5: 'All',
  title6: 'City Map',
  c1: 'Drag the page to see more wonderful buildings City is waiting for you to stroll slowly',
  c2: 'Expand to quickly browse and find the function service you want',
  c3: 'Open CityMap Open CityMap, you can know your current location, and you can quickly reach the place you want to go',
  c4: 'Click the bubble or building to enter the corresponding function service page',
  c5: 'Next',
  c6: 'I got it',
  c7: 'skip',
  c8: 'Press&pull down back',
  c9: 'Coming soon!'
}
